import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiEventManager } from 'ng-jhipster';

import { ILanguage } from 'src/app/shared/model/language.model';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';
import { LanguageService } from './language.service';

@Component({
    selector: 'jhi-language-delete-dialog',
    templateUrl: './language-delete-dialog.component.html'
})
export class LanguageDeleteDialogComponent {
    language: ILanguage;

    constructor(private languageService: LanguageService, 
        public activeModal: NgbActiveModal,
        private eventManager: JhiEventManager,
        private languageChangeService: LanguageChangeService,
        private activatedRoute: ActivatedRoute) {
            this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
        }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.languageService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'languageListModification',
                content: 'Deleted an language'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-language-delete-popup',
    template: ''
})
export class LanguageDeletePopupComponent implements OnInit, OnDestroy {
    private ngbModalRef: NgbModalRef;

    constructor(private activatedRoute: ActivatedRoute, private router: Router, private modalService: NgbModal) {}

    ngOnInit() {
        this.activatedRoute.data.subscribe(({ language }) => {
            setTimeout(() => {
                this.ngbModalRef = this.modalService.open(LanguageDeleteDialogComponent as Component, { size: 'lg', backdrop: 'static' });
                this.ngbModalRef.componentInstance.language = language;
                this.ngbModalRef.result.then(
                    result => {
                        this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.ngbModalRef = null;
                    },
                    reason => {
                        this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.ngbModalRef = null;
                    }
                );
            }, 0);
        });
    }

    ngOnDestroy() {
        this.ngbModalRef = null;
    }
}
